import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "q-ma-none text-error--title" }

import SfxBtn from "src/components/button/SfxBtn.vue"
import { useConfigurationStore } from "src/stores/configurationStore"
import { computed } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogHttpBase',
  props: {
  title: {
    type: String,
    required: true,
  },

  imgSrc: {
    type: String,
    required: true,
  },

  httpCode: {
    type: String,
    required: true,
  },

  btnText: {
    type: String,
  },
},
  emits: ["click"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const configurationStore = useConfigurationStore()
const easterEggsEnabled = computed(() => configurationStore.easterEggs)

const { t } = useI18n()

const buttonLabel = computed(() => props.btnText || t("sfxButtons.btn_close"))
const cardStyle = { width: "400px" }

//endregion

//region Functions

function btnClick() {
  emit("click")
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    class: "q-dialog-plugin text-quote-text text-center text-body1",
    style: cardStyle
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, { class: "text-center" }, {
        default: _withCtx(() => [
          _createElementVNode("h3", _hoisted_1, _toDisplayString(props.title), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_q_card_section, { class: "q-mt-md" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_img, {
            src: props.imgSrc,
            height: "150px",
            fit: "contain"
          }, null, 8, ["src"])
        ]),
        _: 1
      }),
      _createVNode(_component_q_card_section, { class: "q-mt-md" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "body")
        ]),
        _: 3
      }),
      _createVNode(_component_q_card_section, { class: "text-bold q-mt-md" }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, " HTTP " + _toDisplayString(props.httpCode), 1)
        ]),
        _: 1
      }),
      (easterEggsEnabled.value)
        ? (_openBlock(), _createBlock(_component_q_card_section, {
            key: 0,
            class: "text-italic text-body2 q-mt-md"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "quote")
            ]),
            _: 3
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_card_actions, null, {
        default: _withCtx(() => [
          _createVNode(SfxBtn, {
            label: buttonLabel.value,
            class: "col-grow",
            onClick: btnClick
          }, null, 8, ["label"])
        ]),
        _: 1
      })
    ]),
    _: 3
  }))
}
}

})